export default __webpack_public_path__ + "205ad5e1af938c1acc8ee8ea63b8276d.svg";